import { render, staticRenderFns } from "./OsCustomerInactiveBanner.vue?vue&type=template&id=6036d8e6&scoped=true"
import script from "./OsCustomerInactiveBanner.vue?vue&type=script&lang=ts"
export * from "./OsCustomerInactiveBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6036d8e6",
  null
  
)

export default component.exports